/** declare only http service related requests */

import { HttpTokens, GetTrainingList, QueryTrainingList } from '@/src/types';
import { AxiosService } from '@/utils/axios';
import { DEFAULT_HTTP_TIMEOUT } from '../..';
import { AxiosResponse } from 'axios';
import { paramsQueryString } from '@/utils/index';

/**
 * @description Get training list, paginated results, that are sortable by {QueryTrainingList}
 * @param prefix only partial url, base url already prefixed
 * @param {boolean?} hardRejection when soft error is enabled it will return response from .then, and not catch it again, just so you know
 */
export const TrainingListGet = (
  prefix: string = 'trainings',
  params: QueryTrainingList,
  tokens: HttpTokens,
  hardRejection = true
): Promise<GetTrainingList> => {
  const instance = new AxiosService({ method: 'get', timeout: DEFAULT_HTTP_TIMEOUT, apiRef: prefix, proxyType: 'LOCAL_PROXY' }, true, hardRejection);

  const queryUri = paramsQueryString(prefix, params);
  // const nice = niceUrl(instance.baseURL, noSlash('api/' + prefix));
  // token not yet set on backend
  const config = {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      ...(tokens.jwt ? { Authorization: 'Bearer ' + tokens.jwt } : {}),
    },
  };

  return instance.client
    .get(queryUri, config)
    .then((d: AxiosResponse<GetTrainingList>) => {
      // return Promise.reject(new Error('ups')) as any;
      return d.data;
    })
    .catch(instance.defaultHandleError) as Promise<GetTrainingList>;
};
